import { ccpProvider } from 'core/CcpProvider'
import sessionxtd from 'core/sessionxtd'

export const clearCache = () => {
  sessionxtd.removeItem(ccpProvider.api.generateCacheKey(ccpProvider.api.widget.endpoints.WIDGET_GET_CONVERSATIONS, { userUid: CONFIG.userUid }))
}
